module.exports = __webpack_public_path__ + "img/SC-PROOF-3999.33855ad7.png";